module.exports = __webpack_public_path__ + "img/ebn.7ae9b15.jpg";